import { useTheme } from '@emotion/react';
import { IconSearch, IconClearFilled } from '@hubble/icons/web';
import 'react';
import { StyledInput, ClearButton } from './styles.js';
import { searchIcon, clearIcon } from './testIds.js';
import { jsx } from '@emotion/react/jsx-runtime';

const ICON_SIZE_MAP = {
  sm: 'xs',
  md: 'sm',
  lg: 'md'
};
const SearchInput = ({
  hideLabel = true,
  disabled,
  label,
  name = 'search',
  value = '',
  inputSize = 'md',
  variant = 'filled',
  onClear,
  ...props
}) => {
  const {
    translate
  } = useTheme();
  return jsx(StyledInput, {
    disabled: disabled,
    hideLabel: hideLabel,
    inputSize: inputSize,
    label: label || translate('SearchInput.defaultLabel'),
    name: name,
    value: value,
    variant: variant,
    ...props,
    leftElement: jsx(IconSearch, {
      "data-testid": searchIcon,
      size: ICON_SIZE_MAP[inputSize]
    }),
    rightElement: Boolean(value) && Boolean(onClear) ? jsx(ClearButton, {
      onClick: onClear,
      disabled: disabled,
      "aria-label": translate('SearchInput.clearButton'),
      children: jsx(IconClearFilled, {
        "data-testid": clearIcon,
        size: ICON_SIZE_MAP[inputSize]
      })
    }) : null
  });
};

export { SearchInput };
